import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { setAuth, isAuthenticated } from "../lib/auth";
import { Logo } from "../components/Logo";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Crown, Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (isAuthenticated()) nav("/admin");
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      setAuth(r.data.token, r.data.email);
      toast.success("Accesso riuscito");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-midnight flex items-center justify-center px-5 relative overflow-hidden" data-testid="admin-login-page">
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: "url('https://images.pexels.com/photos/12700837/pexels-photo-12700837.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-midnight/40 via-midnight/80 to-midnight" />

      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <Logo size="lg" tone="light" />
          <div className="flex items-center justify-center gap-3 mt-6">
            <Crown size={16} className="text-gold" />
            <p className="text-white/50 text-xs uppercase tracking-[0.3em]">Area riservata Admin</p>
            <Crown size={16} className="text-gold" />
          </div>
        </div>

        <form
          onSubmit={submit}
          className="glass-dark border border-white/10 p-8 md:p-10 space-y-6"
          data-testid="admin-login-form"
        >
          <div>
            <Label className="text-xs uppercase tracking-widest text-white/60 mb-2 block">Email</Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="bg-white/5 border-white/20 text-white rounded-sm placeholder:text-white/30"
              placeholder="rocco@guzzardella-auto.it"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-widest text-white/60 mb-2 block">Password</Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="bg-white/5 border-white/20 text-white rounded-sm"
              placeholder="••••••••"
              data-testid="admin-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-gold w-full py-3 px-6 text-xs uppercase tracking-widest font-semibold flex items-center justify-center gap-2 disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            <Lock size={14} />
            {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>

        <p className="text-center text-white/30 text-xs mt-6">
          Accesso riservato a Rocco Andrea Guzzardella
        </p>
      </div>
    </div>
  );
}
